import { styled } from '@linaria/react';
import { fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  padding: ${space[5]};
  background: ${semantic.bg.surfaceSubtle};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${layout.borderRadiusLg};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  flex: 1;
  min-width: 0;
`;

export const Title = styled.p`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  font-size: ${fonts.size.base};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Subtitle = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  margin: 0;
`;

export const CtaWrapper = styled.div`
  flex-shrink: 0;
`;
